import React from 'react';
import { TriangleBlueIcon } from './icons/TriangleBlueIcon.jsx';

const truncateTreeData = (data, limit = 5) => {
  let itemCount = 0;
  const truncatedData = [];

  for (const parent of data) {
    if (itemCount >= limit) break;

    const truncatedParent = { ...parent, children: [] };
    truncatedData.push(truncatedParent);
    itemCount++;

    for (const child of parent.children || []) {
      if (itemCount >= limit) break;
      truncatedParent.children.push(child);
      itemCount++;
    }
  }

  return truncatedData;
};

const truncateData = (data, limit = 5) => {
  return data.slice(0, limit);
};

const ToggleShowMore = ({
  entities,
  customClass,
  children,
  tree,
  limit = 5,
}) => {
  const [hidden, setHidden] = React.useState(true);

  const getTotalItemsCount = () => {
    if (!tree) return entities.length;

    let count = 0;
    entities.forEach((parent) => {
      count += 1;
      count += (parent.children || []).length;
    });
    return count;
  };

  const renderChildrenWithProps = () => {
    return React.Children.map(children, (child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          entities: hidden
            ? tree
              ? truncateTreeData(entities, limit)
              : truncateData(entities, limit)
            : entities,
        });
      }
      return child;
    });
  };

  return (
    <div className={customClass}>
      <div>{renderChildrenWithProps()}</div>
      {getTotalItemsCount() > limit ? (
        <button
          type="button"
          className="btn-clear bg-transparent btn-link flex"
          onClick={() => setHidden(!hidden)}
          style={{ paddingLeft: 0 }}
        >
          <span className="m-r-8">{hidden ? 'Show More' : 'Show Less'}</span>
          <TriangleBlueIcon
            style={{ height: '20px' }}
            transform={`rotate(${hidden ? '180' : '0'})`}
          />
        </button>
      ) : null}
    </div>
  );
};

export default ToggleShowMore;
